<script>
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
export default {
  name: 'Err404',
  data () {
    return {
      container: null,
    }
  },
  mixins: [
    platformDetect,
  ],

  components: {
    BaseLayout,
  },
  methods: {

  },
}
</script>
<template lang="pug">
base-layout.Err404
  div.backgroundtexture
  div.conteneurerreur
    div.contenuerreur
      div.f2 Oops!
      div.f4.mt2 We could not find the page you are looking for, sorry!
      div.mb5.mt4
          router-link.historybtn(:to="{ name: 'hello'}") Back to main menu
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .backgroundtexture{
  background-image: url("~@/assets/imgs_bg/fond3.jpg");
  background-size: cover;
  background-position: center;
  height: 100%;
  min-height: 100vh;
  width:100vw;
  z-index:-10;
  position:absolute;
  }
  .conteneurerreur{
    height:100vh;
    widht:100vw;
  }
  .contenuerreur{
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  color:white;
  width:80%;
  margin: 0 auto;
  font-family: Abril Fatface;
  }
  .historybtn{
    border: solid white 2px!important;
    border-radius:10px;
    font-family: Abril Fatface!important;
    /*text-transform: uppercase!important;*/
    font-size: 18px;
    color:white!important;
    margin-top: 20px!important;
    background-color: rgba(0,0,0,0.7);
    padding:10px;
  }
</style>



// WEBPACK FOOTER //
// Err404.vue?0fc8f9ba